/**
 * Faqs Section
 *
 * This component requires jQuery and Slick to function.
 * You can require it on the page using <div data-component="faqs"></div>
 */
$(function () {
  $('[data-component="faqs"]').each(function () {
    let $holder = $(this);
    $('.js-faq-link', $holder).click(function (e) {
      e.preventDefault();
      let $this = $(this).next('.js-faq-panel');
      $('.js-faq-panel').not($this).slideUp();

      if (!$(this).parent().hasClass('is-active')) {
        $('.js-faq-item').removeClass('is-active');
        $(this).parent().addClass('is-active');
        $(this).next('.js-faq-panel').slideDown();
      } else {
        $(this).parent().removeClass('is-active');
        $(this).next('.js-faq-panel').slideUp();
      }
    });
  });
});